<div class="legend-item" (click)="selectLegend()" *ngIf="legendItem">
	<div class="legend-circle" [ngStyle]="{'background-color': legendItem.color}" [ngClass]="{'inactive': !legendItem.active}"></div>
	<div class="legend-item-label"  [ngStyle]="{'color': legendItem.color}" [ngClass]="{'inactive': !legendItem.active}"> {{legendItem.name}}</div>
</div>
